/*
Post Types:
-1: Upcoming Fight Placeholder Toast
0: Text Toast
1: Image/Text Toast
2: Social Toast
3: Stat Toast
- statType 0: 2-Fighter Comparison (2 fighters, 1 shared stat metric)
- statType 1: Single Stat (1 fighter, 1 stat metric)
- statType 2: Multi-Stat (1 fighter, 3 stat metrics)
4: Insights Toast
*/

<script setup>
import SocialContent from "@/components/SocialContent.vue";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";


const store = useStore();
const currentTime = ref(Date.now());

const currentToast = computed(() => store.getters.currentToast)

function formatEventName(eventName) {
    if (eventName.includes(':') && eventName.indexOf(':') > 0) {
        return eventName.split(':')[1].trim();
    }
    return eventName.trim();
}

function formatTimestamp(isoString, suffix) {
    const date = new Date(isoString);

    const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
    });

    // Destructure into parts
    const parts = Object.fromEntries(
        formatter.formatToParts(date).map(p => [p.type, p.value])
    );

    const formattedDate = `${parts.weekday}, ${parts.month} ${parts.day} 
        / ${parts.hour}:${parts.minute} ${parts.dayPeriod} ${parts.timeZoneName}`;

    return suffix ? `${formattedDate} / ${suffix}` : formattedDate;
}

onMounted(() => {
    setInterval(() => {
        currentTime.value = Date.now();
    }, 100)
})

</script>

<template>
    <div class="toast-overlay">
        <div class="bottom-section flex-center"
            :class="{ 'has-toast': currentToast != null && currentToast.post.type != -1 }">
            <img class="ufc-bug" src="../../public/assets/imgs/ufc-bug.png">
        </div>
        <div class="toast-area flex-descending-column">
            <transition name="slideup-fade" mode="out-in">
                <div class="toast" v-if="currentToast != null" :key="currentToast.post.id">

                    <!-- [-1] Upcoming Fight Toast -->
                    <div class="toast-modal-card" v-if="currentToast.post.type == -1">
                        <div class="overlay-border"></div>
                        <div class="content-event">
                            <div class="textarea">
                                <div class="event-name">
                                    {{ formatEventName(currentToast.post.body.name) }}
                                </div>
                                <div class="event-date">
                                    {{ formatTimestamp(currentToast.post.body.startTime, "Main Card") }}
                                </div>
                                <div class="event-location">
                                    {{ currentToast.post.body.location.Venue }}
                                </div>
                                <div class="event-location" v-if="currentToast.post.body.location.TriCode === 'USA'">
                                    {{ currentToast.post.body.location.City }}, {{ currentToast.post.body.location.State
                                    }}
                                </div>
                                <div class="event-location" v-else>
                                    {{ currentToast.post.body.location.City }}, {{
                                    currentToast.post.body.location.Country }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- [0/1] Text/Image Toast -->
                    <div class="toast-modal-card" v-if="currentToast.post.type == 0 || currentToast.post.type == 1">
                        <div class="overlay-border"></div>
                        <div class="content-col">
                            <img class="card-image" v-if="currentToast.post.imageData != null"
                                :src="currentToast.post.imageData.dataUri">
                            <div class="textarea">
                                <div class="subtitle">
                                    {{ currentToast.post.body }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- [2] Social Post Toast -->
                    <div class="toast-modal-card" v-else-if="currentToast.post.type == 2">
                        <div class="overlay-border"></div>
                        <social-content :post="currentToast.post.body"></social-content>
                    </div>

                    <!-- [3] Stats Toast -->
                    <div class="toast-modal-card" v-else-if="currentToast.post.type == 3">
                        <div class="overlay-border"></div>
                        <div class="content-stat">
                            <div v-if="currentToast.post.body.statType == 0">
                                <div class="name-row">
                                    <div class="content-name">
                                        {{ currentToast.post.body.fighterName0.FirstName }} {{
                                            currentToast.post.body.fighterName0.LastName }}
                                    </div>
                                    <div class="content-name">
                                        {{ currentToast.post.body.fighterName1.FirstName }} {{
                                            currentToast.post.body.fighterName1.LastName }}
                                    </div>
                                </div>
                                <div class="stat-row">
                                    <div class="stat-left">
                                        {{ currentToast.post.body.statValue0 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName }}
                                    </div>
                                    <div class="stat-right">
                                        {{ currentToast.post.body.statValue1 }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="currentToast.post.body.statType == 1">
                                <div class="content-name">
                                    {{ currentToast.post.body.fighterName.FirstName }} {{
                                        currentToast.post.body.fighterName.LastName }}
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="currentToast.post.body.statType == 2">
                                <div class="content-name">
                                    {{ currentToast.post.body.fighterName.FirstName }} {{
                                        currentToast.post.body.fighterName.LastName }}
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue0 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName0 }}
                                    </div>
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue1 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName1 }}
                                    </div>
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue2 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName2 }}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- [4] Insights Toast -->
                    <div class="toast-modal-card" v-else-if="currentToast.post.type == 4">
                        <div class="overlay-border"></div>
                        <div class="content-row">
                            <img class="card-image" v-if="currentToast.post.imageData != null"
                                :src="currentToast.post.imageData.dataUri">
                            <div class="textarea">
                                <div class="subtitle">
                                    {{ currentToast.post.body.text }}
                                </div>
                            </div>
                        </div>

                        <img class="ufc-insights" src="../../public/assets/imgs/ufc-insights-logo.png">
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';
@import '../sass/ToastStyling.scss';


.slideup-fade-enter-active,
.slideup-fade-leave-active {
    transition: all 1s ease;
}

.slideup-fade-enter-from,
.slideup-fade-leave-to {
    transform: translateY(200%);
    opacity: 0;
}


.toast-overlay {
    overflow: hidden;
    .bottom-section {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: vw(50, $glasses-width);

        opacity: 1;
        transition: opacity 1s ease;

        &.has-toast {
            opacity: 0.33;
        }

        .ufc-bug {
            position: relative;
            width: vw(62, $glasses-width);
        }
    }

    .toast-area {
        position: absolute;
        bottom: vw(50, $glasses-width);
        top: vw(24, $glasses-width);
        left: vw(36, $glasses-width);
        right: vw(36, $glasses-width);

        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        overflow: hidden;

        /* IE and Edge */
        -ms-overflow-style: none;
        scrollbar-width: none;
    
        /* Firefox */
        &::-webkit-scrollbar {
            display: none;
        }

        .toast {
            position: relative;
            width: vw(352, $glasses-width);
            height: fit-content;
            margin: vw(5, $glasses-width) 0;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .content-event {
                text-align: left;

                .event-name {
                    font-weight: 700;
                    font-size: vw(22, $glasses-width);
                    text-transform: uppercase;

                    margin-bottom: vw(2, $glasses-width);
                }

                .event-date {
                    font-weight: 400;
                    font-size: vw(15, $glasses-width);

                    margin-bottom: vw(4, $glasses-width);
                }

                .event-location {
                    font-weight: 400;
                    font-size: vw(12, $glasses-width);
                }
            }

            .content-stat {
                position: relative;
                font-weight: 700;
                font-size: vw(14, $glasses-width);
                text-align: left;
                width: 100%;
                padding: vw(5, $glasses-width);

                .name-row {
                    position: relative;
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: flex-start;
                }

                .stat-row {
                    position: relative;
                    width: 100%;
                    height: auto;
                    display: grid;
                    grid-template-columns: 1fr auto 1fr;
                    align-items: center;
                    column-gap: vw(8, $glasses-width);
                    margin-top: vw(5, $glasses-width);

                    .stat-left {
                        justify-self: start;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        white-space: nowrap;
                        overflow: visible;
                    }

                    .stat-right {
                        justify-self: end;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        white-space: nowrap;
                        overflow: visible;
                    }

                    .stat-name {
                        justify-self: center;
                        align-items: center;
                        width: auto;
                        max-width: vw(135, $glasses-width);
                        font-weight: 400;
                        font-size: vw(16, $glasses-width);
                        text-align: center;
                    }
                }

                .content-name {
                    position: relative;
                    font-weight: 700;
                    font-size: vw(18, $glasses-width);
                    text-transform: uppercase;
                    text-align: left;
                    width: auto;
                    margin-bottom: vw(5, $glasses-width);
                }

                .single-stat {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    height: auto;

                    .value {
                        position: relative;
                        height: auto;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        text-align: left;
                    }

                    .stat-name {
                        position: relative;
                        font-weight: 400;
                        font-size: vw(16, $glasses-width);
                        text-align: left;
                        margin-left: vw(10, $glasses-width);
                    }
                }
            }

            .content-row {
                position: relative;
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;

            }

            .content-col {
                position: relative;
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                gap: vw(12, $glasses-width);
            }

            .card-image {
                position: relative;
                width: 100%;
                max-height: vw(200, $glasses-width);
                object-fit: cover;
                height: auto;
                border-radius: vw(10, $glasses-width);
                margin-right: vw(8, $glasses-width);
            }

            .text-area {
                flex-grow: 1;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
            }

            .title {
                position: relative;
                height: auto;
                text-align: left;
                font-size: vw(16, $glasses-width);
            }

            .subtitle {
                position: relative;
                height: auto;
                text-align: left;
                font-size: vw(22, $glasses-width);
                line-height: vw(26, $glasses-width);
                font-weight: 400;
                text-wrap: wrap;
            }

            .toast-modal-card {
                position: relative;
                width: vw(352, $glasses-width);
                height: fit-content;
                background-color: #27282D;
                border-radius: vw(20, $glasses-width);
                color: $text-0;

                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;

                padding-left: vw(15, $glasses-width);
                padding-right: vw(15, $glasses-width);
                padding-top: vw(15, $glasses-width);
                padding-bottom: vw(15, $glasses-width);

                border: none;

                // &:not(:focus) {
                //     opacity: 0.7;
                // }

                .overlay-border {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 1;
                    opacity: 60%;
                    /* placed behind card's contents (pointer-events: none works too) */
                    border: solid vw(1.25, $glasses-width) #0000;
                    /* reserve space for the border */
                    border-radius: inherit;
                    /* ensure gradient size is relative to border-box (not default padding-box) */
                    background: linear-gradient(20deg, rgba(255, 255, 255, .6) 0%, rgba(0, 0, 0, 0) 100%) border-box;
                    mix-blend-mode: overlay;
                    --lyr: conic-gradient(red 0 0);
                    /* any kind of gradient that's opaque everywhere */
                    /* exclude padding-box (that is, mask out everything but the border area) */
                    mask: var(--lyr) padding-box exclude, var(--lyr);
                    content: ''
                }
            }

        }
    }

}
</style>
